export const MS_PER_SECOND = 1000
export const SECONDS_PER_MINUTE = 60
export const SECONDS_PER_HOUR = SECONDS_PER_MINUTE * 60
export const SECONDS_PER_DAY = SECONDS_PER_HOUR * 24
